var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartner = function SvgPartner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    clipPath: "url(#Partner_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.98a5.73 5.73 0 1 0 0-11.46 5.73 5.73 0 0 0 0 11.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.5 23.48.37-2.05a10.3 10.3 0 0 1 20.26.02l.37 2.05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Partner_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPartner;